import { render } from "./UserLogin.vue?vue&type=template&id=3d5ffa16&ts=true"
import script from "./UserLogin.vue?vue&type=script&lang=ts"
export * from "./UserLogin.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/descript/vue-js-teq-application/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__